import { useState } from "react";
import { HiMenuAlt3, HiX } from "react-icons/hi";

const links = [
  "Home",
  "About",
  "Skills",
  "Services",
  "Projects",
  "Experience",
  "Contact",
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 w-full z-50 backdrop-blur-lg bg-black/30 border-b border-white/10">
      <div className="max-w-7xl mx-auto px-5 h-20 flex justify-between items-center">
        <a
          href="#home"
          className="text-2xl font-bold text-white"
        >
          MQ<span className="text-blue-500">.</span>
        </a>

        <nav className="hidden lg:flex gap-8">
          {links.map((item) => (
            <a
              key={item}
              href={`#${item.toLowerCase()}`}
              className="text-slate-300 hover:text-blue-400 transition"
            >
              {item}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          className="hidden lg:inline-flex px-5 py-3 bg-blue-600 rounded-lg hover:bg-blue-700"
        >
          Hire Me
        </a>

        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden text-3xl text-white"
        >
          {open ? <HiX /> : <HiMenuAlt3 />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-slate-900 border-t border-white/10">
          {links.map((item) => (
            <a
              key={item}
              href={`#${item.toLowerCase()}`}
              className="block px-5 py-4 text-slate-300 hover:bg-slate-800"
              onClick={() => setOpen(false)}
            >
              {item}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}